
import { useState } from "react";
import styles from "../FieldTypeModal.module.scss";
import { ChoseBoolFiledConfig } from "./shared/ChooseBool";
import Button from "../../../../../../../common/components/xepp/button/Button";
import { InputWithClearFiledConfig } from "./shared/InputWithClear";
import { Attribute, FieldType } from "../../../../../../../model/service-request/attribute";
import { v4 as uuidv4 } from 'uuid';

type Props ={
    onFieldSave: (attr: Attribute) => void
    existingAttribute?: Attribute
}

export const DateAndTimeFieldConfiguration = (props : Props) => {
    const [attribute, setAttribute] = useState<Attribute>({
        id: props.existingAttribute ? props.existingAttribute.id : uuidv4(),
        label:props.existingAttribute ? props.existingAttribute.label : "",
        isRequired:props.existingAttribute ? props.existingAttribute.isRequired : false,
        isEnabled:props.existingAttribute ? props.existingAttribute.isEnabled : true,
        isIncludeTimeInformation:props.existingAttribute ? props.existingAttribute.isIncludeTimeInformation : true,
        is24hFormat:props.existingAttribute ? props.existingAttribute.is24hFormat : false,
        fieldType: FieldType.DateTime,
    });

    const clearFieldName = () =>
        setAttribute({ ...attribute, label: "" });


    return <div className={styles.rightSideBody}>
        <div className={styles.configurationForm}>
            <InputWithClearFiledConfig 
                onChange={(val:string)=>{
                        setAttribute({ ...attribute, label: val })
                }}
                onClear = {clearFieldName}
                value ={attribute.label}
                filedLabel="Field Name"
                placeholederText="Enter Field Name"
            />
            
            <ChoseBoolFiledConfig 
                onChange={(val: boolean) => {
                    setAttribute({ ...attribute, isRequired: val });
                    } 
                }
                value={attribute.isRequired}
                option1="Yes"
                option2="No" 
                fieldLabel={"Required"}
            />
            <ChoseBoolFiledConfig 
                onChange={(val: boolean) => {
                    setAttribute({ ...attribute, isIncludeTimeInformation: val });
                    } 
                }
                value={attribute.isIncludeTimeInformation ?? false}
                option1="Yes"
                option2="No" 
                fieldLabel={"Include Time Information"}
            />
            {attribute.isIncludeTimeInformation &&
            
                <ChoseBoolFiledConfig 
                    onChange={(val: boolean) => {
                        setAttribute({ ...attribute, is24hFormat: val });
                        } 
                    }
                    value={attribute.is24hFormat ?? false}
                    option1="24 hours"
                    option2="12 hours" 
                    fieldLabel={"Time Format"}
                />
            }
        </div>
        <div className={styles.saveField}>
            <Button onClick={() => { props.onFieldSave(attribute)}} variant="secondary" text="Save Field" className={styles.saveFieldBtn} />
        </div>
    </div>
}